import axios from 'axios';
import { LocalStorageService } from '../../../services/local-storage-service';
import LoginService from '../../../authentication/login/login-service';
import { addCustomDefaultHeadersToAxiosRequests } from '../../../setup-axios';
import { LogService } from '../../../services/log-service';
import { getAccountInformation } from '../../../store/account-information/account-information.api';

export const phase1Call = () => {
  // oxlint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const promiseData = await Promise.all([
        axios.get('/seller'),
        axios.get('/user/current'),
        axios.get('/pusher/config').catch(() => {
          return {
            data: {
              pusherApps: null,
              primaryPusherApp: window.SS_GLOBALS.frontEndConfig.pusherKey,
            },
          };
        }),
        axios.get('/seller/workstations'),
        getAccountInformation(false),
      ]);
      const [sellerResponse, userResponse, pusherResponse, workstationResponse, accountDataResponse] = promiseData;
      const pusherHasError = pusherResponse.status !== 200;
      const errors = promiseData.filter((response) => response.status !== 200).map((response) => response.statusText);
      if ((pusherHasError && errors.length > 1) || (!pusherHasError && errors.length > 0)) {
        throw new Error(errors.join(','));
      }
      const data = {
        seller: sellerResponse.data,
        currentUser: userResponse.data,
        pusherData: pusherResponse.data,
        workstations: workstationResponse.data,
        accountData: accountDataResponse.data,
      };
      const { sellerId } = sellerResponse.data;

      const { userId } = userResponse.data;
      LogService.extendMetadata({ sellerId, userGuid: userId });
      LocalStorageService.setItem('seller_has_created_label', sellerResponse.data?.hasCreatedLabel || true);
      LoginService.setCurrentUserInfo(userResponse.data);
      addCustomDefaultHeadersToAxiosRequests({
        'X-SS-userId': userResponse.data?.userId,
        'X-SS-sellerId': sellerResponse.data?.sellerId,
      });
      resolve(data);
    } catch (e) {
      reject(e);
    }
  });
};
